
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";

@Component
export default class DeleteAddressPopUp extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: WARNING_POPUP_TYPE }) readonly type!: string;

  showPopup = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  get title() {
    return this.$tc(`title`);
  }

  get text() {
    return this.$tc(`text`);
  }

  async confirm() {
    this.$emit("success");
  }
}
